import { AutoComplete } from '@doopage/react-ui-kit';
import { getProducts, getZaloOA } from 'api/api';
import { AssetImage } from 'assets/Asset';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from 'redux/action/fetchAction';
import { Types } from 'redux/type';
import { getValue } from 'variables/utils';
import { getAllChannels, getFanpages } from '../../redux/action/apiAction';
import { useQuery } from '@redux-requests/react';

const SelectZaloOA = ({ onChange, ...props }) => {
  // const { data = [], error, loading } = useSelector(getValue(Types.selectZaloOA, {}));
  // const dispatch = useDispatch();
  //
  // const getOptions = (value = '') => {
  //   dispatch(
  //     fetchData(Types.selectZaloOA, getZaloOA('?status=publish&page=1&page_size=10&q=' + value)),
  //   );
  // };

  const { data: result, loading, error } = useQuery({ type: getAllChannels });
  const data = result?.data?.filter((item) => item.channel_type === 'zalo_oa') ?? [];

  return (
    <AutoComplete
      style={{ minWidth: 240 }}
      onChange={(value, newValue) => {
        onChange(newValue);
      }}
      options={data.map(({ id, name, image_url }) => ({
        id,
        name,
        image: image_url,
      }))}
      // getData={getOptions}
      loading={loading}
      error={error}
      {...props}
    />
  );
};

export default SelectZaloOA;
